export default {
    aesthetics:  {
        "model_size": {
            "name": "Damsko 750",
            "slug": "damsko-750"
        },
        "cabin_style": {
            "name": "Opened",
            "slug": "open"
        },
        "casco_color": {
            "name": "Batch1",
            "slug": "batch1",
            "code": "#f1f0ea"
        },
        "cushion_color": {
            "name": "Cream",
            "slug": "cream",
            "code": "#e5d8b8"
        },
        "image": "img/aesthetics/batch1_f1f0ea/damsko_750_open/damsko_750_open_f1f0ea_cream_front.png"
    },
    features: {
        "engine": {
            "name": "",
            "details": ""
        },
        "cabin": [
            '',
            ''
        ],
        "anchor_system": {
            "name": "",
            "details": ""
        },
        "roofing": {
            "name": "",
            "details": ""
        },
        "navigation": {
            "name": "Basic (standard)",
            "details": "2x Mercury SC1000 Speedometer"
        },
        "deck_flooring": {
            "name": "Non-skid",
            "details": "Anti slip coating, UV resistant Color: black (other colors optional)"
        },
        "bow_thruster": {
            "name": "",
            "details": ""
        },
        "audio": {
            "name": "",
            "details": ""
        },
        "lighting": [
            '',
            '',
            ''
        ],
        "boat_gadgets": [
            '',
            '',
            '',
            '',
            '',
            {
                "name": "Enquire later",
                "details": "",
                "image": "img/features/no_feature.png"
            }
        ]
    },
}